import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const Card = ({
title,
tagline,
bestFor,
gain,
image,
link,
}) => {
return ( <Link
   to={link}
   className="
     group
     relative
     block
     overflow-hidden
     rounded-[36px]
     bg-white/20
     backdrop-blur-2xl
     border
     border-white/30
     shadow-[0_30px_80px_rgba(20,10,0,.08)]
     transition-all
     duration-500
     hover:-translate-y-2
     hover:shadow-[0_40px_100px_rgba(20,10,0,.12)]
   "
 >
{/* IMAGE */} <div className="relative overflow-hidden"> <img
       src={image}
       alt={title}
       className="
         w-full
         h-[320px]
         object-cover
         transition-transform
         duration-700
         group-hover:scale-105
       "
     />


    {/* IMAGE OVERLAY */}
    <div
      className="
        absolute
        inset-0
        bg-gradient-to-t
        from-black/40
        via-transparent
        to-transparent
      "
    />
  </div>

  {/* CONTENT */}
  <div
    className="
      relative
      p-7
      bg-white/25
      backdrop-blur-2xl
      border-t
      border-white/20
    "
  >
    {/* GLOW */}
    <div
      className="
        absolute
        top-0
        right-0
        w-40
        h-40
        bg-[#F4CDA8]/30
        blur-3xl
        rounded-full
      "
    />

    <div
      className="
        absolute
        bottom-0
        left-0
        w-32
        h-32
        bg-[#F28C28]/10
        blur-3xl
        rounded-full
      "
    />

    <div className="relative z-10">
      {/* TAG */}
      <div
        className="
          inline-flex
          items-center
          px-3
          py-1.5
          rounded-full
          bg-white/40
          backdrop-blur-xl
          border
          border-white/30
          text-[#C26B2E]
          text-[15px]
          uppercase
          tracking-[0.18em]
          font-medium
          mb-5
        "
      >
        {tagline}
      </div>

      {/* TITLE */}
      <h3
        className="
          text-[32px]
          leading-[1.05]
          tracking-[-0.04em]
          text-secondary
          mb-4
        "
        
      >
        {title}
      </h3>

      {/* DESCRIPTION */}
      <p
        className="
          text-[#5F5751]
          text-[15px]
          leading-8
          mb-5
          line-clamp-3
        "
      >
        {gain}
      </p>

      {/* BEST FOR */}
      <div
        className="
          rounded-[18px]
          bg-white/30
          backdrop-blur-xl
          border
          border-white/30
          p-4
          mb-6
        "
      >
      </div>

      {/* CTA */}
      <div
        className="
          inline-flex
          items-center
          gap-2
          text-[#C26B2E]
          font-semibold
          text-sm
          transition-all
          duration-300
          group-hover:gap-3
        "
      >
        View Program
        <ArrowRight size={15} />
      </div>
    </div>
  </div>
</Link>


);
};

export default Card;
